import { ErrorMessage, Field, FieldArray, Form, Formik } from "formik";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  EditWelfareValidationSchema,
  WelfareIntialValues,
} from "../../constant";
import { useMutateEditWelfare } from "../../hooks/useApiHook";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import InputWithLabel from "../../../../Components/InputWithLabel";
import selectIcon from "../../../../assets/Images/selecticon.png";
import TextArea from "../../../../Components/TextArea";
import { Switch } from "../../../../Components";
import { useMutateCreateImage } from "../../../Discover/hooks/useApiHook";
import IconUpload from "../../../../Components/SingleProfileSelect";
import PhoneInput from "react-phone-input-2";
import { useQuery } from "@tanstack/react-query";
import { GetSingleWelfare } from "../../../../Api/welfare";
import { removeSecureItem } from "../../../../Utils/secureStorage";
import BackButton from "../../../../Components/BackButton";
import SaveButton from "../../../../Components/SaveButton";

const EditWelfare = () => {
  const navigate = useNavigate();
  const formRef = useRef();
  const stateData = useLocation();
  const [variations, setVariations] = useState([]);

  const addImageApi = useMutateCreateImage();

  const [removeItem, setRemoveItem] = useState([]);
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [uploadingSectionIndex, setUploadingSectionIndex] = useState(null);

  const { id } = stateData?.state || "";

  const editWelfare = useMutateEditWelfare();
  var variationsValueOptions = [];

  const { data } = useQuery({
    queryKey: ["get-single-product"],
    queryFn: () => GetSingleWelfare({ id: id }),
    throwOnError: (error) => {
      ErrorToast(error?.response?.data?.message || "Server Error.");
    },
  });

  useEffect(() => {
    if (data) {
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          name: data?.data?.name || "-",

          section: data?.data?.section.map((item) => ({
            ...item,
            // phoneNumber: item?.phoneNumber.replace(item?.phoneCode, ""),
            phoneNumber: item?.phoneNumber ? `${item?.phoneCode} ${item?.phoneNumber}` : "",
          })),
        });
      }
    }
  }, [data]);

  const handleImageError = (event) => {
    event.target.src = selectIcon;
  };

  function getLastNameFromUrl(url) {
    const parts = url.split("/");
    return parts[parts.length - 1];
  }
  const handleSubmitEditWelfare = (values) => {

    const reqData = {
      id: id,
      name: values?.name,
      section: values?.section.map((item) => {
        const logoUrl =
          typeof item.logo === "object"
            ? item?.logo?.imgRes
            : getLastNameFromUrl(item?.logo);
        const phoneCode = (item?.phoneCode && !item?.phoneCode?.includes("+")) ? `${"+"}${item?.phoneCode}` : (item?.phoneCode || "");
        let phoneNumber = item?.phoneNumber;

        if (phoneNumber && phoneCode) {
          if (phoneNumber.includes(`${phoneCode} `)) {
            phoneNumber = phoneNumber?.replace(`${phoneCode} `, "");
          } else if (phoneNumber.includes(`${phoneCode}`)) {
            phoneNumber = phoneNumber?.replace(phoneCode, "");
          } else if (phoneNumber.includes(item?.phoneCode)) {
            phoneNumber = phoneNumber.replace(item?.phoneCode, "");
          }
        }

        return {
          ...item,
          logo: logoUrl,
          logo_url: item?.logo,
          phoneCode: phoneCode,
          phoneNumber: phoneNumber || "",
          // phoneNumber: `${item?.phoneCode} ${item?.phoneNumber}`,
          // phoneNumber: item?.phoneNumber.replace(item?.phoneCode, ""),
        };
      }),
    };

    setIsLoading(true);
    editWelfare.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response?.message || "Product Updated.");
        navigate("/admin/welfare-listing");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        if (error?.response?.status === 401) {
          removeSecureItem("accessToken");
          navigate("/");
        }
        setIsLoading(false);
      },
    });
  };

  useEffect(() => {
    variations?.forEach(function (element) {
      variationsValueOptions.push({
        ...element,
        label: element?.name,
        value: element?.id,
      });
    });
  }, [variationsValueOptions]);

  return (
    <>
      <Helmet>
        <title>OVE | Admin Edit Welfare</title>
      </Helmet>
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="row">
            <div className="col-md-12">
              <div className="card card-border overflow-visible">
                <div className="card-body">
                  <div className="page-header d-block">
                    <div className="row">
                      <div className="col">
                        <h3 className="page-title">Edit Welfare</h3>
                      </div>
                      <div className="col-auto d-flex align-items-center justify-content-center">
                        <BackButton to="/admin/welfare-listing" />
                      </div>
                    </div>
                  </div>

                  <Formik
                    initialValues={WelfareIntialValues}
                    validationSchema={EditWelfareValidationSchema}
                    validateOnChange
                    innerRef={formRef}
                    onSubmit={handleSubmitEditWelfare}
                  >
                    {(formik) => {
                      const { setFieldValue, values } = formik;

                      return (
                        <Form>
                          <div className="row">
                            <div className="col-md-6">
                              <Field
                                Label="Name"
                                type="text"
                                name="name"
                                placeholder="Enter Welfare Name"
                                component={InputWithLabel}
                              />
                            </div>
                          </div>
                          <div>
                            <h4>Section</h4>
                          </div>

                          <div className="row">
                            <FieldArray name="section">
                              {({ push, remove }) => (
                                <div>
                                  {values?.section?.map((section, index) => (
                                    <section
                                      key={index}
                                      className="section-welfare-border"
                                    >
                                      <div className="row justify-content-end">
                                        <div className="col-auto text-end">
                                          {values.section.length > 1 && (
                                            <svg
                                              stroke="none"
                                              fill="#AD5ADC"
                                              strokeWidth="32"
                                              viewBox="0 0 24 24"
                                              height="35px"
                                              width="35px"
                                              xmlns="http://www.w3.org/2000/svg"
                                              onClick={() => remove(index)}
                                            >
                                              <g id="Circle_Remove">
                                                <g>
                                                  <path d="M9.525,13.765a.5.5,0,0,0,.71.71c.59-.59,1.175-1.18,1.765-1.76l1.765,1.76a.5.5,0,0,0,.71-.71c-.59-.58-1.18-1.175-1.76-1.765.41-.42.82-.825,1.23-1.235.18-.18.35-.36.53-.53a.5.5,0,0,0-.71-.71L12,11.293,10.235,9.525a.5.5,0,0,0-.71.71L11.293,12Z"></path>
                                                  <path d="M12,21.933A9.933,9.933,0,1,1,21.934,12,9.945,9.945,0,0,1,12,21.933ZM12,3.067A8.933,8.933,0,1,0,20.934,12,8.944,8.944,0,0,0,12,3.067Z"></path>
                                                </g>
                                              </g>
                                            </svg>
                                          )}
                                        </div>
                                      </div>
                                      <div>
                                        <div className="row">
                                          <div className="col-3">
                                            <label>Logo</label>

                                            <div>
                                              <div>
                                                <label className="image-upload-label">
                                                  {uploadingSectionIndex === index ? (
                                                    <div className="d-flex align-items-center justify-content-center border rounded" style={{ width: '100px', height: '100px', background: '#f7f5f5' }}>
                                                      <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                      </div>
                                                    </div>
                                                  ) : (
                                                    <>
                                                      {!values?.section[index]
                                                        ?.logo && (
                                                          <img
                                                            src={selectIcon}
                                                            alt="profile_picture"
                                                            height={100}
                                                            width={100}
                                                            className="upload-image w-sm-70 h-sm-70 rounded"
                                                            name={`section.${index}.logo`}
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          />
                                                        )}

                                                      {values?.section[index]
                                                        ?.logo &&
                                                        typeof values?.section[
                                                          index
                                                        ]?.logo === "string" && (
                                                          <img
                                                            src={
                                                              values?.section[index]
                                                                ?.logo_url
                                                            }
                                                            height={100}
                                                            width={100}
                                                            alt="profile_picture"
                                                            className="upload-image w-sm-70 h-sm-70 rounded"
                                                            name={`section.${index}.logo`}
                                                            onError={
                                                              handleImageError
                                                            }
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          />
                                                        )}

                                                      {values?.section[index]
                                                        ?.logo &&
                                                        typeof values?.section[
                                                          index
                                                        ]?.logo === "object" && (
                                                          <img
                                                            src={
                                                              values?.section[index]
                                                                ?.logo?.image
                                                            }
                                                            alt="profile_picture"
                                                            className="upload-image w-sm-70 h-sm-70 rounded"
                                                            name={`section.${index}.logo`}
                                                            style={{
                                                              cursor: "pointer",
                                                            }}
                                                          />
                                                        )}
                                                    </>
                                                  )}

                                                  <input
                                                    type="file"
                                                    multiple={false}
                                                    name={`section.${index}.logo`}
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    className="filetype d-none"
                                                    onChange={(event) => {
                                                      if (
                                                        event.target.files &&
                                                        event.target.files[0]
                                                      ) {
                                                        event.preventDefault();

                                                        const file =
                                                          event.target.files[0];
                                                        const temporaryURL =
                                                          URL.createObjectURL(
                                                            file
                                                          );

                                                        setFieldValue(
                                                          `section[${index}].logo`,
                                                          {
                                                            image: temporaryURL,
                                                          }
                                                        );

                                                        setUploadingSectionIndex(index);
                                                        const formData =
                                                          new FormData();
                                                        formData.append(
                                                          "images",
                                                          file
                                                        );

                                                        addImageApi.mutate(
                                                          formData,
                                                          {
                                                            onSuccess: (
                                                              response
                                                            ) => {
                                                              setFieldValue(
                                                                `section[${index}].logo`,
                                                                {
                                                                  image:
                                                                    temporaryURL,
                                                                  imgRes:
                                                                    getLastNameFromUrl(
                                                                      response
                                                                        ?.data[0]
                                                                    ),
                                                                }
                                                              );
                                                              setUploadingSectionIndex(null);
                                                            },
                                                            onError: (
                                                              error
                                                            ) => {
                                                              ErrorToast(
                                                                error?.response
                                                                  ?.data
                                                                  ?.message ||
                                                                "Server error."
                                                              );
                                                              setUploadingSectionIndex(null);
                                                            },
                                                          }
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </label>
                                              </div>

                                              <div className="image-upload-label">
                                                <label className="user-icon-change-profile-button">
                                                  {uploadingSectionIndex === index ? (
                                                    <span className="d-flex align-items-center gap-1">
                                                      <div className="spinner-border spinner-border-sm" role="status"></div>
                                                      Uploading...
                                                    </span>
                                                  ) : (
                                                    <>{values?.section[index]?.logo ? "Change" : "Select"} Icon</>
                                                  )}
                                                  <input
                                                    type="file"
                                                    multiple={false}
                                                    name={`section.${index}.logo`}
                                                    accept="image/png, image/jpeg, image/jpg"
                                                    className="filetype d-none"
                                                    onChange={(event) => {
                                                      if (
                                                        event.target.files &&
                                                        event.target.files[0]
                                                      ) {
                                                        event.preventDefault();

                                                        const file =
                                                          event.target.files[0];
                                                        const temporaryURL =
                                                          URL.createObjectURL(
                                                            file
                                                          );

                                                        setFieldValue(
                                                          `section[${index}].logo`,
                                                          {
                                                            image: temporaryURL,
                                                          }
                                                        );

                                                        setUploadingSectionIndex(index);
                                                        const formData =
                                                          new FormData();
                                                        formData.append(
                                                          "images",
                                                          file
                                                        );

                                                        addImageApi.mutate(
                                                          formData,
                                                          {
                                                            onSuccess: (
                                                              response
                                                            ) => {
                                                              setFieldValue(
                                                                `section[${index}].logo`,
                                                                {
                                                                  image:
                                                                    temporaryURL,
                                                                  imgRes:
                                                                    getLastNameFromUrl(
                                                                      response
                                                                        ?.data[0]
                                                                    ),
                                                                }
                                                              );
                                                              setUploadingSectionIndex(null);
                                                            },
                                                            onError: (
                                                              error
                                                            ) => {
                                                              ErrorToast(
                                                                error?.response
                                                                  ?.data
                                                                  ?.message ||
                                                                "Server error."
                                                              );
                                                              setUploadingSectionIndex(null);
                                                            },
                                                          }
                                                        );
                                                      }
                                                    }}
                                                  />
                                                </label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-md-6">
                                            <Field
                                              Label="Name"
                                              type="text"
                                              name={`section.${index}.name`}
                                              placeholder="Enter name"
                                              component={InputWithLabel}
                                            />
                                            <div className="row mb-4">
                                              <div className="col-12">
                                                <label>Phone Number</label>
                                                <PhoneInput
                                                  name={`section.${index}.phoneNumber`}
                                                  country="gb"
                                                  countryCodeEditable={false}
                                                  value={
                                                    values?.section[index]
                                                      .phoneNumber
                                                  }
                                                  onChange={(
                                                    phone1,
                                                    phone2,
                                                    phone3
                                                  ) => {

                                                    setFieldValue(
                                                      `section.${index}.phoneNumber`,
                                                      phone1
                                                    );
                                                    setFieldValue(
                                                      `section.${index}.phoneCode`,
                                                      phone2.dialCode
                                                    );
                                                  }}
                                                  inputStyle={{
                                                    background: "#F7F5F5",
                                                    height: "38px",
                                                    boxShadow: "none",
                                                    borderRadius: "8px",
                                                    width: "100%",
                                                  }}
                                                />
                                              </div>
                                            </div>
                                            <div className="row mb-2">
                                              <div className="col-12">
                                                <Field
                                                  Label="Helpline Number"
                                                  type="text"
                                                  name={`section.${index}.helplineNumber`}
                                                  placeholder="Enter Helpline Number"
                                                  component={InputWithLabel}
                                                  require={false}
                                                />
                                              </div>
                                            </div>
                                          </div>

                                          <div className="col-md-6">
                                            <Field
                                              Label="Description"
                                              name={`section.${index}.description`}
                                              placeholder="Enter Product Description"
                                              component={TextArea}
                                              handleChange={(e) => {
                                                setFieldValue(
                                                  `section.${index}.description`,
                                                  e.value
                                                );
                                              }}
                                              require={false}
                                            />
                                          </div>
                                        </div>

                                        <div className="row">
                                          <div className="col-md-6">
                                            <Field
                                              Label="Website"
                                              type="text"
                                              name={`section.${index}.website`}
                                              placeholder="Enter Website"
                                              component={InputWithLabel}
                                              require={false}
                                            />
                                          </div>

                                          <div className="col-md-6">
                                            <Field
                                              Label="Opening Hours"
                                              type="text"
                                              name={`section.${index}.openingHours`}
                                              placeholder="Enter Opening Hours"
                                              component={InputWithLabel}
                                              require={false}
                                            />
                                          </div>
                                        </div>
                                        <div className="row">
                                          <div className="form-group col-md-12">
                                            <label className="d-block">
                                              Live Help Chat
                                            </label>
                                            <div className="switch-handler">
                                              <Switch
                                                name={`section.${index}.liveHelpChat`}
                                                checked={
                                                  values?.section[index]
                                                    ?.liveHelpChat || false
                                                }
                                                onChange={(event) => {
                                                  const checked =
                                                    event.target.checked;
                                                  setFieldValue(
                                                    `section.${index}.liveHelpChat`,
                                                    checked
                                                  );
                                                }}
                                                color="primary"
                                                size="medium"
                                              />
                                            </div>
                                            <ErrorMessage
                                              name={`section.${index}.liveHelpChat`}
                                              component="span"
                                              className="error d-block"
                                            />
                                          </div>
                                        </div>

                                        {values?.section[index]
                                          ?.liveHelpChat && (
                                            <div className="row">
                                              <div className="col-md-6">
                                                <Field
                                                  Label="Live Help Chat Link"
                                                  type="text"
                                                  name={`section.${index}.liveHelpChatLink`}
                                                  placeholder="Enter Live Help Chat Link"
                                                  component={TextArea}
                                                  className="custom-product-input"
                                                />
                                              </div>

                                              <div className="col-md-6">
                                                <Field
                                                  Label="Live Help Chat Description"
                                                  type="text"
                                                  name={`section.${index}.liveHelpChatDescription`}
                                                  placeholder="Enter Live Help Chat Description"
                                                  component={TextArea}
                                                  className="welfare-live-discription"
                                                  style={{ height: "100px" }}
                                                  require={false}
                                                />
                                              </div>
                                            </div>
                                          )}
                                      </div>
                                    </section>
                                  ))}
                                  <div className="row my-3 justify-content-end">
                                    <div className="col-auto">
                                      <button
                                        className="text-end custom-addveriationsection-button"
                                        type="button"
                                        onClick={() =>
                                          push({
                                            name: "",
                                            logo: null,
                                            description: "",
                                            website: "",
                                            phoneCode: "",
                                            phoneNumber: "",
                                            helplineNumber: "",
                                            liveHelpChat: false,
                                            liveHelpChatLink: "",
                                            openingHours: "",
                                            liveHelpChatDescription: "",
                                          })
                                        }
                                      >
                                        Add Section
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </FieldArray>
                          </div>

                          <SaveButton loading={isLoading} />
                        </Form>
                      );
                    }}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditWelfare;
